import { Capacitor } from '@capacitor/core';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const NATIVE_BYPASS_TOKEN = 'NATIVE_APP';

export const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const execute = async (action: string): Promise<string | null> => {
    // Bypass reCAPTCHA for native Capacitor apps (WebView doesn't support it)
    if (Capacitor.isNativePlatform()) {
      return NATIVE_BYPASS_TOKEN;
    }

    if (!executeRecaptcha) return null;

    return executeRecaptcha(action);
  };

  const isRecaptchaReady = Capacitor.isNativePlatform() || Boolean(executeRecaptcha);

  return { executeRecaptcha: execute, isRecaptchaReady };
};
